export default __webpack_public_path__ + "static/media/hubspot_cert.c287f8b5.png";